module.exports = __webpack_public_path__ + "img/LU_gia高機能美容精華液.8c42b5f4.png";